import React from 'react'
import { NodeViewWrapper } from '@tiptap/react'
import { Plane } from 'lucide-react'
import './FlightItineraryNode.css'

export default function FlightItineraryNode({ node, selected }) {
  const { flights, passengerName } = node.attrs

  // Default to empty array if no flights
  const flightList = flights || []

  return (
    <NodeViewWrapper className={`flight-itinerary-wrapper ${selected ? 'selected' : ''}`}>
      <div className="flight-itinerary-container" contentEditable={false}>
        {/* Header */}
        <div className="flight-itinerary-header">
          <Plane className="h-5 w-5" />
          <span className="flight-itinerary-title">Flight Itinerary</span>
          {passengerName && (
            <span className="flight-itinerary-passenger">
              Passenger: {passengerName}
            </span>
          )}
        </div>

        {/* Flight Segments */}
        {flightList.length > 0 ? (
          <div className="flight-segments">
            {flightList.map((flight, index) => (
              <div key={index} className="flight-segment">
                <div className="flight-route">
                  <div className="airport-info">
                    <span className="airport-code">{flight.origin}</span>
                  </div>
                  <div className="flight-arrow">
                    <Plane className="h-4 w-4" />
                  </div>
                  <div className="airport-info">
                    <span className="airport-code">{flight.destination}</span>
                  </div>
                </div>

                <div className="flight-details">
                  <div className="flight-number">
                    <span className="label">Flight</span>
                    <span className="value">{flight.flightNumber}</span>
                  </div>
                  <div className="flight-times">
                    <div className="time-info">
                      <span className="label">Departure</span>
                      <span className="value">{flight.departure}</span>
                    </div>
                    <div className="time-info">
                      <span className="label">Arrival</span>
                      <span className="value">{flight.arrival}</span>
                    </div>
                  </div>
                </div>

                {index < flightList.length - 1 && (
                  <div className="flight-separator">
                    <div className="connection-line"></div>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="flight-empty">
            <p>No flights added</p>
          </div>
        )}
      </div>
    </NodeViewWrapper>
  )
}
